import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AssessmentContext } from "../../contexts/assessments";
import { Box, Container } from "@mui/material";
import BannerBlock from "../../components/BannerBlock";
import QuestionsSection from "../../components/QuestionsSection";
import { getAnswersByBlockAndUser, getAnswersByBlockAndUser360, getAnswersByBlockAndUserTIM, getUserTIMRol } from "../../axios/axiosFunctions";
import { UserContext } from "../../contexts/user";
import { GroupContext } from "../../contexts/group";

const AssessmentBlock = () => {

    const navigate = useNavigate();
    const {currentUser} = useContext(UserContext);
    const {currentGroup} = useContext(GroupContext);
    const {slugAssessment,slugBlock}=useParams();
    const [currentBlock, setCurrentBlock] = useState();
    const [currentAnswers, setCurrentAnswers] = useState([]);
    const [buttonDir, setButtonDir] = useState("");
    const [is360Assessment, setIs360Assessment] = useState(false);
    const [isTim, setIsTim] = useState(false)
    const {getBlockBySlug,getAssessmentBySlug,getPositionBlockBySlug,isLoading} = useContext(AssessmentContext);

    useEffect(() => {
        const callUserType = async()=>{
            if(!isLoading){
                let dir;
                const block = getBlockBySlug(slugAssessment,slugBlock);
                if(currentGroup){
                    const res = await getUserTIMRol(currentGroup?._id,currentUser._id);
                    const rol = res.timRol[0]?.rol || "member";
                    dir = getPositionBlockBySlug(slugAssessment,slugBlock,rol);
                    setIsTim(true);

                    // Enforce role-based block access for TIM assessments
                    const assessment = getAssessmentBySlug(slugAssessment);
                    if(assessment?.blocks?.length > 0){
                        const lastBlock = assessment.blocks[assessment.blocks.length - 1];
                        // Members cannot access the senior-only block (last block)
                        if(rol === "member" && lastBlock?.slug === slugBlock){
                            navigate(`/${slugAssessment}`);
                            return;
                        }
                        // Seniors can only access the last block
                        if(rol === "senior" && lastBlock?.slug !== slugBlock){
                            navigate(`/${slugAssessment}`);
                            return;
                        }
                    }
                }else{
                    dir = getPositionBlockBySlug(slugAssessment,slugBlock);
                }
                setButtonDir(dir);
                if(!block){
                    navigate('/');
                    return;
                }
                setCurrentBlock(block);
            }
        }
        callUserType();
    }, [slugAssessment,slugBlock,isLoading])
    
    useEffect(() => {
        if(slugAssessment === "mim_360_assessment" || slugAssessment === "lim_360_assessment"){
            setIs360Assessment(true); 
        }
    }, []);

    useEffect(() => {
      if(currentBlock){
        const requestAnswers = async()=>{
            if(currentGroup){
                const res =  await getAnswersByBlockAndUserTIM(currentBlock._id,currentUser._id,currentGroup._id);
                setCurrentAnswers(res.answers);
            }else{
                let res;
                if(slugAssessment === "mim_360_assessment" || slugAssessment === "lim_360_assessment"){
                    res =  await getAnswersByBlockAndUser360(currentBlock._id,currentUser._id);
                    
                }else{
                    res =  await getAnswersByBlockAndUser(currentBlock._id,currentUser._id);
                }
                setCurrentAnswers(res.answers);
            }
        }
        requestAnswers();
      }
    }, [currentBlock,currentUser,currentGroup])

    return (
    <Container maxWidth="false" sx={{padding:"0px !important"}}>
        <BannerBlock name={currentBlock?.name} color={currentBlock?.color}/>
        <Box display="flex" flexDirection="column" alignItems="center">
            <QuestionsSection is360Assessment={is360Assessment} blockId={currentBlock?._id} questions={currentBlock?.questions} color={currentBlock?.color} buttonsDir={buttonDir} currentAnswers={currentAnswers} setCurrentAnswers={setCurrentAnswers} isTim={isTim}/>
        </Box>
    </Container>
    )
}

export default AssessmentBlock